<template>
  <div class="page overflow-hidden">
    <div class="ml-auto mr-auto" style="width: 300px; margin-top: 100px">
      <b-card>
        <h2 class="text-center">Login</h2>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="username">Username</label>
            <input
              type="text"
              v-model="VFUID"
              name="username"
              class="form-control"
              :class="{ 'is-invalid': submitted && !VFUID }"
            />
            <div v-show="submitted && !VFUID" class="invalid-feedback">
              Username is required
            </div>
          </div>
          <div class="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              v-model="password"
              name="password"
              class="form-control"
              :class="{ 'is-invalid': submitted && !password }"
            />
            <div v-show="submitted && !password" class="invalid-feedback">
              Password is required
            </div>
            <b-alert
              :show="status.errorMessage !== ''"
              variant="danger"
              dismissible
              class="mt-3"
            >
              {{ status.errorMessage }}
            </b-alert>
          </div>
          <div class="form-group">
            <button class="btn btn-primary w-100" :disabled="status.loggingIn">
              Login
            </button>
            <img
              v-show="status.loggingIn"
              src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
            />
          </div>
        </form>
      </b-card>
    </div>
  </div>
</template>

<script>
import router from "../router";
import { authService } from "../services/auth.service";

export default {
  data() {
    return {
      VFUID: "",
      password: "",
      submitted: false,
      status: {
        loggingIn: false,
        errorMessage: ""
      }
    };
  },
  created() {
    // reset login status
    this.logout();
  },
  methods: {
    login(credentials) {
      authService
        .login(credentials.VFUID, credentials.password)
        .then(() => {
          router.push("/");
        })
        .catch(err => {
          this.status.errorMessage = err;
        });
    },
    logout() {
      // console.log(auth);
    },
    handleSubmit() {
      this.submitted = true;
      const { VFUID, password } = this;
      if (VFUID && password) {
        this.login({ VFUID, password });
      }
    }
  }
};
</script>
